import { Directive } from '@angular/core';

@Directive({
  selector: '[prEventableHeaderTitle]',
  standalone: false,
})
export class EventableHeaderTitleDirective {}
